import React, { useEffect, useRef, useState } from 'react';

const BackPricesBoxExch = ({
  price,
  position,
  validationBM,
  getLock,
  getBoxValue,
}) => {
  const [highlighted, setHighlighted] = useState(['']);

  const prevPricesRef = useRef([
    { price: null, size: null }
  ]);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      prevPricesRef.current[position] = {
        price: price,
      }
      return;
    }

    const newHighlights = [''];
    let changed = false;
    const prev = prevPricesRef.current[position];

      if (price !== prev?.price) {
        if (price > prev?.price) {
          newHighlights[position] = 'higilighted';
        } else if (price < prev?.price) {
          newHighlights[position] = 'higilighted';
        }

        prevPricesRef.current[position] = { price: price };
        changed = true;

        setTimeout(() => {
          setHighlighted((prev) => {
            const updated = [...prev];
            updated[position] = '';
            return updated;
          });
        }, 500);
      }

    if (changed) {
      setHighlighted(newHighlights);
    }
  }, [price]);

  const renderSpan = (index, className) => {
    return (
      <span className={`${className} ${highlighted[index]}`}>
        {validationBM(price) ? getBoxValue(price) : getLock()}
      </span>
    );
  };

  return (
    <>
      {renderSpan(position, 'blue')}
    </>
  );
};

export default BackPricesBoxExch;